var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBandwidth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 16.9191H17.8333V16.0858H21.1667V15.6691C21.1667 10.617 17.052 6.50235 12 6.50235C6.94797 6.50235 2.83328 10.617 2.83328 15.6691V16.0858H6.16672V16.9191H2V15.6691C2 10.1535 6.48441 5.66907 12 5.66907C17.5156 5.66907 22 10.1535 22 15.6691V16.9191Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5835 6.08575H12.4169V8.58575H11.5835V6.08575Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1142 9.0264L7.13232 11.0445L6.54318 11.6338L4.5249 9.61569L5.1142 9.0264Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8863 9.02701L19.4756 9.6163L17.4573 11.6344L16.8682 11.0451L18.8863 9.02701Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1196 18.5857C10.906 18.5857 9.9165 17.596 9.9165 16.3825C9.9165 15.5388 10.4112 14.7576 11.1717 14.3929L16.7967 11.7107L14.1143 17.3357C13.7498 18.0909 12.9686 18.5857 12.1196 18.5857ZM15.0311 13.4711L11.531 15.143C11.0571 15.3669 10.7498 15.8565 10.7498 16.3825C10.7498 17.1378 11.3644 17.7523 12.1196 17.7523C12.6457 17.7523 13.13 17.445 13.3592 16.971L15.0311 13.4711Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBandwidth);
export default __webpack_public_path__ + "static/media/icon-bandwidth.8bf749d0fc26379265dc242749125a7a.svg";
export { ForwardRef as ReactComponent };